import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getContractHideColumnData = createApi('cdPlannerHiddenColumns', 'GET');

const GetContractHideColumns = createSlice({
  name: 'GetContractHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractHideColumnData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractHideColumnData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getContractHideColumnData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetContractHideColumns.reducer;